import { useState } from 'react';

const AddKishuMarkPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddKishuPopup, setShowAddKishuPopup] = useState<boolean>(false);

    const addToggleHandler = () => {
      setShowAddKishuPopup(!showAddKishuPopup);
    };

    return (
      <Component
        showAddKishuPopup={showAddKishuPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddKishuMarkPopupHOC;
